import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import styled from 'styled-components';
import { DisclosedAlias } from '../../../../types/report';

const FieldLabel = styled.span`
  margin-bottom: 0.5rem;
  display: block;
`;

const FirstGridCol = styled(M.GridCol)`
  padding-left: 0;
`;

interface DisclosedAliasesProps {
  aliases: DisclosedAlias[];
}

const DisclosedAliases: React.FC<DisclosedAliasesProps> = ({ aliases }) => {
  // Don't render anything if there are no aliases
  if (!aliases || aliases.length === 0) {
    return null;
  }

  const getAliasTitle = (index: number) => {
    return (
      <span>
        <T value='labels.otherName' /> {index + 1}
      </span>
    );
  };

  return (
    <div className='mt-3'>
      <div className='md-flex mb-3'>
        <div>
          <div className='mb-3 font-weight-bold'>
            <T value='labels.otherNames' />
          </div>
        </div>

        <div>
          {aliases.map((alias, index) => {
            const isLast = index === aliases.length - 1;

            return (
              <React.Fragment
                // eslint-disable-next-line react/no-array-index-key
                key={`alias-${index}`}
              >
                <div className='mb-3'>{getAliasTitle(index)}</div>

                <M.Grid>
                  <M.GridRow className={isLast ? 'mb-0' : 'mb-md-4'}>
                    <FirstGridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>
                        <T value='labels.firstName' />
                      </FieldLabel>
                      {alias.firstName || '-'}
                    </FirstGridCol>
                    <M.GridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>
                        <T value='labels.middleName' />
                      </FieldLabel>
                      {alias.middleName || '-'}
                    </M.GridCol>
                    <M.GridCol className='mb-3 mb-md-0'>
                      <FieldLabel className='text-very-muted'>
                        <T value='labels.lastName' />
                      </FieldLabel>
                      {alias.lastName || '-'}
                    </M.GridCol>
                  </M.GridRow>
                </M.Grid>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DisclosedAliases;
